export default function () {
  return {
    current: {
      id: '',
      apiToken: '',
      apiUrl: '',
      name: '',
      subscription: 0,
      user: null
    },
    update: {
      apiToken: '',
      apiUrl: '',
      name: '',
      subscription: 0,
      user: null
    },
    list: []
  }
}
